<template>
  <p>
    Несколько советом при работе с нейросетью:
  </p>
  <ol>
    <li class="form-group">
      Формулировка запросов:
      <ul class="marked-ul">
        <li>Пишите четко и конкретно</li>
        <li>Разбивайте сложные вопросы на простые</li>
        <li>Указывайте контекст и детали</li>
      </ul>
    </li>
    <li class="form-group">
      Проверка информации:
      <ul class="marked-ul">
        <li>Не принимайте ответы нейросети как истину в последней инстанции</li>
        <li>Перепроверяйте важную информацию</li>
        <li>Помните, что нейросеть может ошибаться</li>
      </ul>
    </li>
    <li class="form-group">
      Эффективное взаимодействие:
      <ul class="marked-ul">
        <li>Начинайте с простых запросов</li>
        <li>Уточняйте ответы при необходимости</li>
        <li>Сохраняйте успешные промптыг</li>
        <li>Экспериментируйте с формулировками</li>
      </ul>
    </li>
    <li class="form-group">
      Безопасность:
      <ul>
        <li>Не делитесь личной информацией</li>
        <li>Не передавайте конфиденциальные данные</li>
      </ul>
    </li>
  </ol>
  <p>
    Помните, что работа с нейросетями - это навык, который улучшается с практикой!
  </p>
</template>